<template>
	<section class="about">
		<div class="about-bg-section">
			<img
				class="lazy d-none d-lg-block"
				style="
					position: absolute;
					left: 0px;
					top: 0px;
					height: 75%;
					width: 100%;
					object-fit: cover;
				"
				alt=""
				src="../../assets/images/about-us-bg.jpg"
				width=""
				height=""
			/>
		</div>
		<div class="container">
			<div class="row align-items-center">
				<div class="col-12 col-lg-6 col-sm-12 mb-4 mb-lg-0">
					<div class="video-area-wrapper d-flex juctify-content-center">
						<img
							class="lazy ml-auto mr-auto"
							alt="MN Webbased is one of the prominent mobile application development companies in the UK, offering iPhone (iOS) &amp; Android app development services."
							src="../../assets/images/about-us-video.jpg"
							style=""
							width="600"
							height="550"
						/>
						<div class="hover">
							<!-- <a href="assets/images/video/mobile-app-development.mp4" class="video-play-btn mfp-iframe"><i class="fas fa-play"></i></a> -->
							<!-- <a href="https://player.vimeo.com/video/282873577?title=0&portrait=0&byline=0&autoplay=1" class="video-play-btn mfp-iframe"><i class="fas fa-play"></i></a> -->
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 col-sm-12">
					<div class="title text-left">
						<span>Who We Are</span>
						<h2>About MN Webbased</h2>
					</div>
					<h3 class="mb-3">
						A bunch of digitally inspired guys with a passion for all things game, web
						and mobile application development.
					</h3>
					<p>
						MN Webbased are a web and mobile app development company headquartered in
						Nagpur, India. We had a humble start in life, beginning as a small group of
						three; two being founders of the group and the other a full time mobile app
						developer on the payroll.
					</p>
					<p>
						Today, almost a decade later, through determination and a passion for
						technology, MN Webbased has evolved into a globally renowned digital agency,
						recognised as a leader in web and mobile app development in the India and
						globally. From mobile app development to eCommerce development, to virtual
						reality to augmented reality app development — we offer a wide spectrum of
						IT services backed by our best app developers.
					</p>
					<p>
						What makes us unique compared with other mobile app development companies in
						India is that we approach every project as an opportunity to deliver bespoke
						solutions in state-of-the-art technologies. At MN Webbased , perfection is
						not just another trait, but a way of life that we have become habitual to.
						Rest assured, when you partner with us, you are shaking hands with a strong
						ally who can make your digital dreams come true.
					</p>
				</div>
			</div>

			<ul class="counter-section row">
				<li class="col-12 col-sm-6 col-lg-3">
					<svg
						version="1.1"
						id="Layer_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 150 150"
						style="enable-background: new 0 0 150 150"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									class="st0"
									d="M142.5,75H140V22c0-7-5.6-12.6-12.5-12.6h-105C15.6,9.4,10,15,10,22v37.9H7.5c-4.1,0-7.5,3.4-7.5,7.6v65.6    c0,4.2,3.4,7.6,7.5,7.6h95c1.4,0,2.5-1.1,2.5-2.5c0-7-5.6-12.6-12.5-12.6H85v-15.1h30v22.7c0,4.2,3.4,7.6,7.5,7.6h20    c4.1,0,7.5-3.4,7.5-7.6V82.6C150,78.4,146.6,75,142.5,75z M55,133.1c0,1.4-1.1,2.5-2.5,2.5h-45c-1.4,0-2.5-1.1-2.5-2.5v-2.5h50    V133.1z M55,125.5H5V67.4c0-1.4,1.1-2.5,2.5-2.5h45c1.4,0,2.5,1.1,2.5,2.5V125.5z M92.5,130.5c3.2,0,6,2,7.1,5h-40    c0.3-0.8,0.5-1.7,0.5-2.5v-2.5H92.5z M60,125.5v-15.1h5v15.1H60z M70,125.5v-15.1h10v15.1H70z M115,105.3H60V90.1h55V105.3z     M115,82.6v2.5H60V67.4c0-1.2-0.3-2.4-0.9-3.4c0,0,0.1,0,0.1-0.1l24.7-25c1-1,0.9-2.6-0.1-3.6c-1-0.9-2.5-0.9-3.5,0l-24.8,25    c-0.1,0.1-0.1,0.1-0.1,0.2c-1-0.5-2-0.7-3.1-0.7H15V22c0-4.2,3.4-7.6,7.5-7.6h105c4.1,0,7.5,3.4,7.5,7.6v53h-12.5    C118.4,75,115,78.4,115,82.6z M145,133.1c0,1.4-1.1,2.5-2.5,2.5h-20c-1.4,0-2.5-1.1-2.5-2.5v-2.5h25V133.1z M145,125.5h-25V82.6    c0-1.4,1.1-2.5,2.5-2.5h20c1.4,0,2.5,1.1,2.5,2.5V125.5z M29.9,90.6c-1-1-2.6-1-3.5,0l-10.6,10.7c-1,1-1,2.6-0.1,3.6    c1,1,2.5,1,3.5,0.1c0,0,0,0,0.1-0.1l10.6-10.7C30.3,93.4,29.4,91.9,29.9,90.6z M41.3,90.6l-10.6,10.7c-1,1-1,2.6-0.1,3.6    c1,1,2.5,1,3.5,0.1c0,0,0,0,0.1-0.1l10.6-10.7c1-1,0.9-2.6-0.1-3.6C43.8,89.6,42.3,89.6,41.3,90.6z M95.7,35.3L71,60.3    c-1,1-1,2.6-0.1,3.6c1,1,2.5,1,3.5,0.1c0,0,0,0,0.1-0.1l24.8-25c1-1,0.9-2.6-0.1-3.6C98.2,34.4,96.7,34.4,95.7,35.3z M134.3,97.4    l-7.1,7.1c-1,1-1,2.6-0.1,3.6c1,1,2.5,1,3.5,0.1c0,0,0,0,0.1-0.1l7.1-7.1c1-1,0.9-2.6-0.1-3.6C136.8,96.5,135.2,96.5,134.3,97.4z     M75,100.2c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5h0c-1.4,0-2.5,1.1-2.5,2.5C72.5,99.1,73.7,100.3,75,100.2z M80,19.5H70    c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5h10c1.4,0,2.5-1.1,2.5-2.5C82.5,20.6,81.4,19.5,80,19.5z"
								/>
							</g>
						</g>
					</svg>
					<div class="counter_text">
						<div class="counter" data-count="150">150</div>
						<i class="fas fa-plus"></i>
						<p>
							Successfully<br />
							Developed Projects
						</p>
					</div>
				</li>
				<li class="col-12 col-sm-6 col-lg-3">
					<svg
						version="1.1"
						id="Layer_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 150 150"
						style="enable-background: new 0 0 150 150"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									class="st0"
									d="M147.1,97.9h-4.9c-0.7-2.6-1.8-5-3-7.3l3.4-3.4c1.1-1.1,1.1-3,0-4.1l-9.9-9.9c-1.1-1.1-3-1.1-4.1,0l-3.4,3.4    c-2.3-1.3-4.8-2.3-7.4-3.1v-4.8c0-1.6-1.3-2.9-2.9-2.9h-11.7c1.2-4.1,1.8-8.5,1.8-13.2c0-14-5.5-27.2-15.4-37.1    C79.6,5.5,66.5,0,52.5,0c0,0,0,0,0,0C23.5,0,0,23.5,0,52.5c0,13.2,4.9,24.4,14.5,33.3c9.6,8.8,15.7,20.7,17.1,33.3l0,0.1v23.3    c0,4.2,3.4,7.6,7.6,7.6h26.5c4.2,0,7.6-3.4,7.6-7.6V133l9.6,9.6c1.1,1.1,3,1.1,4.1,0l3.4-3.4c2.3,1.3,4.8,2.3,7.3,3v4.8    c0,1.6,1.3,2.9,2.9,2.9h14c1.6,0,2.9-1.3,2.9-2.9v-4.9c2.6-0.7,5-1.8,7.3-3l3.4,3.4c1.1,1.1,3,1.1,4.1,0l9.9-9.9    c1.1-1.1,1.1-3,0-4.1l-3.4-3.4c1.3-2.3,2.3-4.8,3-7.3h4.9c1.6,0,2.9-1.3,2.9-2.9v-14C150,99.2,148.7,97.9,147.1,97.9z M67.5,142.4    c0,1-0.8,1.8-1.8,1.8H39.2c-1,0-1.8-0.8-1.8-1.8v-6.4h30V142.4z M67.5,130.1h-30v-8.2h30V130.1z M67.8,116h-5.4v-6.2    c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9v6.2h-8.2V79.6c0-0.3,0-0.5-0.1-0.8l-6.4-23.2l0.9,0.9c1.1,1.1,3,1.1,4.1,0l4.8-4.8    l4.8,4.8c1.1,1.1,3,1.1,4.1,0l3-3l-7,25.3c-0.1,0.3-0.1,0.5-0.1,0.8v9.1c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9V80l6.7-24.4    l1,1c0.6,0.6,1.3,0.9,2.1,0.9c0.7,0,1.5-0.3,2.1-0.9c1.1-1.1,1.1-3,0-4.1l-6.8-6.8c-1.1-1.1-3-1.1-4.1,0l-4.8,4.8l-4.8-4.8    c-1.1-1.1-3-1.1-4.1,0l-4.8,4.8l-4.8-4.8c-1.1-1.1-3-1.1-4.1,0l-6.8,6.8c-1.1,1.1-1.1,3,0,4.1c1.1,1.1,3,1.1,4.1,0l2.2-2.2    L42.5,80v36h-5.4c-2-13.2-8.6-25.4-18.7-34.6C10.1,73.7,5.9,64,5.9,52.5c0-25.7,20.9-46.6,46.6-46.6h0c12.4,0,24.1,4.8,32.9,13.6    C94.2,28.3,99,40,99,52.5c0,11.5-4.2,21.3-12.6,28.9C76.4,90.6,69.9,102.9,67.8,116z M73.3,128.2v-9.1l0-0.1c0-0.3,0.1-0.7,0.1-1    c0.7,2.5,1.7,4.8,3,7.1L73.3,128.2z M144.1,111.9h-4.2c-1.4,0-2.6,1-2.9,2.3c-0.8,3.5-2.1,6.8-4,9.8c-0.7,1.2-0.6,2.7,0.4,3.7l3,3    l-5.8,5.8l-3-3c-1-1-2.5-1.1-3.7-0.4c-3,1.9-6.3,3.3-9.8,4c-1.3,0.3-2.3,1.5-2.3,2.9v4.2h-8.2v-4.2c0-1.4-1-2.6-2.3-2.9    c-3.5-0.8-6.8-2.1-9.8-4c-1.2-0.7-2.7-0.6-3.7,0.4l-3,3l-5.8-5.8l3-3c1-1,1.1-2.5,0.4-3.7c-1.9-3-3.3-6.3-4.1-9.8    c-0.3-1.3-1.5-2.3-2.9-2.3h-1c2.6-9.9,8-19,15.8-26.2c1.8-1.6,3.4-3.4,4.9-5.2c0,0,0,0,0.1,0c1.9-0.9,4-1.6,6-2    c1.3-0.3,2.3-1.5,2.3-2.9v-4.2h8.2v4.2c0,1.4,1,2.6,2.3,2.9c3.5,0.8,6.8,2.1,9.8,4.1c1.2,0.7,2.7,0.6,3.7-0.4l3-3l5.8,5.8l-3,3    c-1,1-1.1,2.5-0.4,3.7c1.9,3,3.3,6.3,4,9.8c0.3,1.4,1.5,2.3,2.9,2.3h4.2V111.9z M107.8,86.1c-12,0-21.7,9.7-21.7,21.7    c0,12,9.7,21.7,21.7,21.7c12,0,21.7-9.7,21.7-21.7C129.5,95.9,119.8,86.1,107.8,86.1z M107.8,123.6c-8.7,0-15.8-7.1-15.8-15.8    c0-8.7,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8C123.6,116.5,116.5,123.6,107.8,123.6z M107.8,96.7c-6.1,0-11.1,5-11.1,11.1    c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1C118.9,101.7,113.9,96.7,107.8,96.7z M107.8,113.1c-2.9,0-5.3-2.4-5.3-5.3    c0-2.9,2.4-5.3,5.3-5.3c2.9,0,5.3,2.4,5.3,5.3C113.1,110.7,110.7,113.1,107.8,113.1z M59.5,96.8c-0.8,0-1.5,0.3-2.1,0.9    c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1c0.5,0.6,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9c0.5-0.5,0.9-1.3,0.9-2.1    c0-0.8-0.3-1.5-0.9-2.1C61,97.1,60.3,96.8,59.5,96.8z M131.2,50.6c1.6,0,2.9-1.3,2.9-2.9V18.7c0-1.6-1.3-2.9-2.9-2.9    s-2.9,1.3-2.9,2.9v28.9C128.3,49.3,129.6,50.6,131.2,50.6z M131.2,62.4c0.8,0,1.5-0.3,2.1-0.9c0.5-0.5,0.9-1.3,0.9-2.1    c0-0.8-0.3-1.5-0.9-2.1c-0.5-0.5-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1    C129.7,62.1,130.5,62.4,131.2,62.4z"
								/>
							</g>
						</g>
					</svg>
					<div class="counter_text">
						<div class="counter" data-count="150">150</div>
						<i class="fas fa-plus"></i>
						<p>Unique <br />Ideas Submitted</p>
					</div>
				</li>
				<li class="col-12 col-sm-6 col-lg-3">
					<svg
						version="1.1"
						id="Layer_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 150 150"
						style="enable-background: new 0 0 150 150"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									class="st0"
									d="M147.1,0H2.9C1.3,0,0,1.3,0,2.9v128.3c0,1.6,1.3,2.9,2.9,2.9h60.8c1.6,0,2.9-1.3,2.9-2.9    c0-1.6-1.3-2.9-2.9-2.9H5.9V26.9c0.1,0,0.2,0,0.3,0h138v101.4h-5.7c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9h8.6    c1.6,0,2.9-1.3,2.9-2.9V2.9C150,1.3,148.7,0,147.1,0z M144.1,21.1H6.2c-0.1,0-0.2,0-0.3,0V5.9h138.3V21.1z M76.2,128.3    c-0.8,0-1.5,0.3-2.1,0.9c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1c0.5,0.5,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9    c0.5-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1C77.7,128.6,76.9,128.3,76.2,128.3z M65.1,16.4h66.2c1.6,0,2.9-1.3,2.9-2.9    c0-1.6-1.3-2.9-2.9-2.9H65.1c-1.6,0-2.9,1.3-2.9,2.9C62.1,15.1,63.4,16.4,65.1,16.4z M30.5,16.4c0.8,0,1.5-0.3,2.1-0.9    c0.5-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1c-0.5-0.5-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9c-0.5,0.5-0.9,1.3-0.9,2.1    c0,0.8,0.3,1.5,0.9,2.1C28.9,16.1,29.7,16.4,30.5,16.4z M18.8,16.4c0.8,0,1.5-0.3,2.1-0.9c0.5-0.5,0.9-1.3,0.9-2.1    c0-0.8-0.3-1.5-0.9-2.1c-0.5-0.5-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1    C17.2,16.1,18,16.4,18.8,16.4z M42.2,16.4c0.8,0,1.5-0.3,2.1-0.9c0.5-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1    c-0.5-0.5-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1C40.7,16.1,41.4,16.4,42.2,16.4    z M86.8,106.7l-1.3-7.5l5.4-5.3c1-0.9,1.3-2.3,0.9-3.6c-0.4-1.3-1.5-2.2-2.8-2.4l-7.5-1.1L78.1,80c0,0,0,0,0,0    c-0.6-1.2-1.8-2-3.2-2c0,0,0,0,0,0c-1.3,0-2.6,0.7-3.2,2l-3.4,6.8L61,87.9c-1.3,0.2-2.4,1.1-2.8,2.4c-0.4,1.3-0.1,2.7,0.9,3.6    l5.4,5.3l-1.3,7.5c-0.2,1.3,0.3,2.6,1.4,3.4c0.6,0.4,1.3,0.7,2.1,0.7c0.6,0,1.1-0.1,1.6-0.4l6.7-3.5l6.7,3.5    c1.2,0.6,2.6,0.5,3.7-0.3C86.5,109.3,87.1,108,86.8,106.7z M80.6,95.8c-0.8,0.8-1.2,2-1,3.1l0.7,4l-3.6-1.9c-1-0.5-2.2-0.5-3.3,0    l-3.6,1.9l0.7-4c0.2-1.1-0.2-2.3-1-3.1L66.5,93l4-0.6c1.1-0.2,2.1-0.9,2.6-1.9l1.8-3.7l1.8,3.7c0.5,1,1.5,1.8,2.6,1.9l4,0.6    L80.6,95.8z M50.4,90.3c-0.4-1.3-1.5-2.2-2.8-2.4l-7.5-1.1L36.7,80c0,0,0,0,0,0c-0.6-1.2-1.8-2-3.2-2c0,0,0,0,0,0    c-1.3,0-2.6,0.7-3.2,2L27,86.8l-7.5,1.1c-1.3,0.2-2.4,1.1-2.8,2.4c-0.4,1.3-0.1,2.7,0.9,3.6l5.4,5.3l-1.3,7.5    c-0.2,1.3,0.3,2.6,1.4,3.4c0.6,0.4,1.3,0.7,2.1,0.7c0.6,0,1.1-0.1,1.6-0.4l6.7-3.5l6.7,3.5c1.2,0.6,2.6,0.5,3.7-0.3    c1.1-0.8,1.6-2.1,1.4-3.4l-1.3-7.5l5.4-5.3C50.5,92.9,50.8,91.6,50.4,90.3z M39.1,95.8c-0.8,0.8-1.2,2-1,3.1l0.7,4l-3.6-1.9    c-1-0.5-2.2-0.5-3.3,0l-3.6,1.9l0.7-4c0.2-1.1-0.2-2.3-1-3.1L25.1,93l4-0.6c1.1-0.2,2.1-0.9,2.6-1.9l1.8-3.7l1.8,3.7    c0.5,1,1.5,1.8,2.6,1.9l4,0.6L39.1,95.8z M133.3,90.3c-0.4-1.3-1.5-2.2-2.8-2.4l-7.5-1.1l-3.4-6.8c-0.6-1.2-1.8-2-3.2-2    c0,0,0,0,0,0c-1.3,0-2.6,0.7-3.2,2c0,0,0,0,0,0l-3.4,6.8l-7.5,1.1c-1.3,0.2-2.4,1.1-2.8,2.4c-0.4,1.3-0.1,2.7,0.9,3.6l5.4,5.3    l-1.3,7.5c-0.2,1.3,0.3,2.6,1.4,3.4c1.1,0.8,2.5,0.9,3.7,0.3l6.7-3.5l6.7,3.5c0.5,0.3,1.1,0.4,1.6,0.4c0.7,0,1.4-0.2,2.1-0.7    c1.1-0.8,1.6-2.1,1.4-3.4l-1.3-7.5l5.4-5.3C133.4,92.9,133.7,91.6,133.3,90.3z M122,95.9c-0.8,0.8-1.2,2-1,3.1l0.7,4l-3.6-1.9    c-0.5-0.3-1.1-0.4-1.6-0.4c-0.6,0-1.1,0.1-1.6,0.4l-3.6,1.9l0.7-4c0.2-1.1-0.2-2.3-1-3.1L108,93l4-0.6c1.1-0.2,2.1-0.9,2.6-1.9    l1.8-3.7l1.8,3.7c0.5,1,1.5,1.8,2.6,1.9l4,0.6L122,95.9z M134.2,69.1V37.5c0-1.6-1.3-2.9-2.9-2.9H18.8c-1.6,0-2.9,1.3-2.9,2.9    v31.6c0,1.6,1.3,2.9,2.9,2.9h112.5C132.9,72.1,134.2,70.8,134.2,69.1z M128.3,66.2H21.7V53.3h43.4c1.6,0,2.9-1.3,2.9-2.9    c0-1.6-1.3-2.9-2.9-2.9H21.7v-7h106.6V66.2z M138.4,136.5c-1.7,0-3.4,0.4-4.8,1.2c-1.4-3.7-5.1-6.4-9.3-6.4c-2.7,0-5.2,1.1-7,2.9    c-1.8-1.8-4.3-2.9-7-2.9c-1.5,0-2.9,0.3-4.1,0.9v-17.3c0-5.5-4.5-10-10-10c-5.5,0-10,4.5-10,10v32.2c0,1.6,1.3,2.9,2.9,2.9    c1.6,0,2.9-1.3,2.9-2.9v-32.2c0-2.3,1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1v32.2c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9    v-5.8c0-2.3,1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1v5.8c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9v-5.8c0-2.3,1.8-4.1,4.1-4.1    c2.3,0,4.1,1.8,4.1,4.1v5.8c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9v-0.6c0-2.3,1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1    c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9C148.4,141,143.9,136.5,138.4,136.5z M78.2,53.3c0.8,0,1.5-0.3,2.1-0.9    c0.5-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2.1c-0.5-0.5-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9c-0.5,0.5-0.9,1.3-0.9,2.1    c0,0.8,0.3,1.5,0.9,2.1C76.7,53,77.5,53.3,78.2,53.3z"
								/>
							</g>
						</g>
					</svg>
					<div class="counter_text">
						<div class="counter" data-count="90">90</div>
						<i class="fas fa-percent"></i>
						<p>Verified <br />5 Star Client Reviews</p>
					</div>
				</li>
				<li class="col-12 col-sm-6 col-lg-3">
					<svg
						version="1.1"
						id="Layer_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 150 150"
						style="enable-background: new 0 0 150 150"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									class="st0"
									d="M74.9,128.1c-0.8,0-1.5,0.3-2.1,0.8c-0.5,0.5-0.9,1.3-0.9,2c0,0.8,0.3,1.5,0.9,2.1c0.5,0.5,1.3,0.8,2.1,0.8    c0.8,0,1.5-0.3,2.1-0.8c0.5-0.5,0.9-1.3,0.9-2.1c0-0.8-0.3-1.5-0.9-2C76.5,128.5,75.7,128.1,74.9,128.1z M134.3,80.3l-9.8-2.3    v-3.8c5.4-3.4,9-9.4,9-16.2V47.2c0-10.6-8.7-19.1-19.3-19.1c-5.8,0-10.9,2.5-14.5,6.5c-3.1-10.6-13-18.4-24.8-18.4h0    c-11.8,0-21.7,7.8-24.8,18.5c-3.5-4-8.7-6.5-14.5-6.5c-10.7,0-19.3,8.6-19.3,19.1V58c0,6.8,3.6,12.8,9,16.2V78l-9.8,2.3    C6.4,82.5,0,90.6,0,100v19.5c0,1.6,1.3,2.9,2.9,2.9h23.4v8.7c0,1.6,1.3,2.9,2.9,2.9h32.1c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9    H48.3v-12.8c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9v12.8H32.2v-13.1c0-9.8,6.7-18.3,16.4-20.6L63,91.1l9.3,20.9    c0.5,1.1,1.5,1.7,2.7,1.7h0c1.2,0,2.2-0.7,2.7-1.7l9.3-20.8l14.4,3.4c9.7,2.3,16.4,10.8,16.4,20.6v3.2c-0.1,0.3-0.2,0.7-0.2,1.1    c0,0.4,0.1,0.8,0.2,1.1v7.6h-10.2v-12.8c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9v12.8H87.3c-1.6,0-2.9,1.3-2.9,2.9    s1.3,2.9,2.9,2.9h33.3c1.6,0,2.9-1.3,2.9-2.9v-8.7h23.5c1.6,0,2.9-1.3,2.9-2.9V100C150,90.6,143.6,82.5,134.3,80.3z M114.3,33.8    c7.4,0,13.5,6,13.5,13.3v0.7v0.3h-8.4c-6.3,0-12.5-1.6-18-4.8C103,37.9,108.2,33.8,114.3,33.8z M100.8,57.5c0-0.3,0-7.8,0-7.8    c5.8,2.8,12.1,4.3,18.6,4.3h8.4v4c0,7.4-6,13.3-13.5,13.3c-7.4,0-13.5-6-13.5-13.3V57.5z M55.1,41.6c0-10.9,8.9-19.7,19.9-19.7    S95,30.7,95,41.6V42l-10.9-6.3c-1.2-0.7-2.8-0.4-3.7,0.6c-4.2,5-10.4,7.9-17,7.9h-8.2V41.6z M22.3,47.9v-0.7    c0-7.4,6-13.3,13.5-13.3c6.1,0,11.3,4.1,12.9,9.6c-5.5,3.1-11.7,4.8-18,4.8h-8.4V47.9z M22.3,58v-4h8.4c6.5,0,12.8-1.5,18.6-4.3    V58c0,7.4-6,13.3-13.5,13.3C28.3,71.3,22.3,65.3,22.3,58z M26.4,115.1v1.5h-8.8v-12.9c0-1.6-1.3-2.9-2.9-2.9    c-1.6,0-2.9,1.3-2.9,2.9v12.9H5.9V100c0-6.7,4.6-12.4,11.2-14l9.3-2.2l6.1,14.4C28.6,102.8,26.4,108.7,26.4,115.1z M35.7,91.1    l-4.4-10.5c0-0.1,0-0.1,0-0.2v-3.7c1.4,0.3,2.9,0.5,4.4,0.5c1.5,0,3-0.2,4.4-0.5v3.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3    L35.7,91.1z M47.3,88.8c-1.7,0.4-3.4,1-5,1.7l2.9-6.8l9.3,2.2c0.7,0.2,1.4,0.4,2.1,0.7L47.3,88.8z M61.8,82.8    c-1.8-1.1-3.9-2-6-2.5L46,78v-3.8c2.4-1.5,4.5-3.6,6.1-6c2.2,4.3,5.6,7.8,9.7,10.3V82.8z M82.3,87.1L75,103.6l-7.3-16.5v-6    c2.3,0.7,4.8,1.1,7.4,1.1c2.5,0,5-0.4,7.3-1V87.1z M75,76.3c-11,0-19.9-8.8-19.9-19.7v-6.7h8.2c7.5,0,14.6-2.9,19.8-8.1l11.8,6.9    v8.6C94.6,67.9,85.8,76.3,75,76.3z M88.2,78.6L88.2,78.6c4.2-2.5,7.6-6,9.8-10.3c1.5,2.4,3.6,4.4,6,5.9V78l-9.8,2.3    c-2.1,0.5-4.2,1.4-6,2.5V78.6z M102.7,88.8l-9.3-2.2c0.7-0.3,1.4-0.5,2.2-0.7l9.3-2.2l2.9,6.8C106.1,89.8,104.4,89.3,102.7,88.8z     M109.8,80.6c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1v-3.6c1.4,0.3,2.9,0.5,4.4,0.5c1.5,0,3-0.2,4.4-0.5v3.7c0,0.1,0,0.1,0,0.2    l-4.5,10.6L109.8,80.6z M144.1,116.5h-5.9v-12.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9v12.9h-8.8v-1.5    c0-6.3-2.2-12.3-6-16.9l6.1-14.4L133,86c6.6,1.6,11.2,7.3,11.2,14V116.5z M65.2,52.5c-0.8,0-1.5,0.3-2.1,0.8    c-0.5,0.5-0.9,1.3-0.9,2c0,0.8,0.3,1.5,0.9,2c0.5,0.5,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9c0.5-0.5,0.9-1.3,0.9-2    c0-0.8-0.3-1.5-0.9-2C66.7,52.8,65.9,52.5,65.2,52.5z M84.8,52.5c-0.8,0-1.5,0.3-2.1,0.8c-0.5,0.5-0.9,1.3-0.9,2    c0,0.8,0.3,1.5,0.9,2c0.5,0.5,1.3,0.9,2.1,0.9c0.8,0,1.5-0.3,2.1-0.9c0.5-0.5,0.9-1.3,0.9-2c0-0.8-0.3-1.5-0.9-2    C86.3,52.8,85.5,52.5,84.8,52.5z M76.5,63.1c-0.9,0.9-2.3,0.9-3.1,0c-1.1-1.1-3-1.1-4.1,0c-1.1,1.1-1.1,3,0,4.1    c1.6,1.6,3.6,2.3,5.7,2.3s4.1-0.8,5.7-2.3c1.1-1.1,1.1-3,0-4.1C79.5,62,77.6,62,76.5,63.1z"
								/>
							</g>
						</g>
					</svg>
					<div class="counter_text">
						<div class="counter ml-2" data-count="40">40</div>
						<i class="fas fa-plus"></i>
						<p>Professionals <br />in Our Team</p>
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
export default {};
</script>

<style>
.about {
	background: #fff;
}
.counter-section {
	display: flex !important;
	margin: 60px auto 0 !important;
}
.counter-section li {
	max-width: 150px;
	display:flex;
}
.counter-section li svg {
	min-width: 50px;
}
@media (max-width: 991px) {
	.counter-section {
		min-width: 100vw;
	}
}
@media (max-width: 776px) {
	.counter-section li:nth-child(4) .counter_text div {
		margin-left: 0 !important;
	}
	.counter-section .counter_text div {
		font-size: 14px;
	}
	.counter-section .counter_text .counter  {
		font-size: 24px !important;
		font-weight:bold !important;
	}
	.counter-section .counter_text i {
		font-size: 18px !important;
		font-weight:bold !important;
	}
	.counter-section .counter_text p {
		font-size: 14px !important;
	}
}
@media (max-width: 576px) {
	.counter-section {
		justify-content:start;
		margin-bottom:0 !important
	}
	.counter-section li:before {
			right: -10px !important;
	}
	.counter-section li:nth-child(2n):before {
			display:none;
	}
	.counter-section li {
		padding: 0 !important;
		flex-direction: column;
		align-items: start !important;
		gap:5px;
		width:fit-content !important;
		margin-right:30px
	}
	.counter-section .counter_text div,
	.counter-section .counter_text p {
		margin-left: 0 !important;
	}
	.counter-section .counter_text i {
		margin-right: 0 !important;
	}
	.counter-section li:nth-child(4) .counter_text div {
		margin-left: 0px !important;
	}

}
</style>
